module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_3_CIUDADANO.091fcb6c.jpg";